export enum ROUTE {
  APP = 'app',
  DASHBOARD = 'dashboard',
  DIRECT_FLOW = 'direct-flow',
  IMPRINT = 'imprint',
  THANK_YOU = 'thank-you',
  LOGIN = 'login',
  MEETING_FLOW = 'meeting-flow',
  NEW_USER = 'new-user',
  FORGOT_PASSWORD = 'forgot-password',
  SET_PASSWORD = 'set-password',
  FIRST_LOGIN = 'first-login',
  PAGE_NOT_FOUND = '404',
  NUTZUNGSBEDINGUNGEN = 'https://www.enerix.de/nutzungsbedingungen-kundenportal',
  DATENSCHUTZHINWEISE = 'https://www.enerix.de/datenschutz',
  USER_PROFILE = 'user-profile',
}
